import { ButtonContainer, Button, Link, Label, Hidden, StatefulIcon } from './styles'

ButtonContainer.Button = Button
ButtonContainer.Link = Link
ButtonContainer.Label = Label
ButtonContainer.Hidden = Hidden
ButtonContainer.StatefulIcon = StatefulIcon

export default ButtonContainer
